import QuestionForm from '../../../../factories/QuestionForm'
import MessagesAccordian from '../../Common/MessagesAccordian'
import NavigationButtons from '../../Common/NavigationButton'

const TeamsComponent = ({
  questions,
  formData,
  buttonColour,
  buttonTextColour,
  next,
  onSubmit = () => {},
  defaultValue,
  defaultCountry,
  preventDefaultOnBack,
  teamsByCode,
  getTeamsByCode,
  teamCodes,
  teamsInEvent,
  onChange = () => {},
  disableQuestions,
  teamsByCodeInEvent,
  isNextDisabled,
  teamWelcomeMessages,
}) => {
  let submit = () => {}

  const searchOnClick = searchValue => {
    getTeamsByCode(searchValue)
  }

  return (
    <div>
      {teamWelcomeMessages && <MessagesAccordian messages={teamWelcomeMessages} title="Messages from:" />}

      <h2>Team Registration</h2>
      <hr />

      <QuestionForm
        questions={questions}
        formData={formData}
        bindHandler={({ submitForm }) => {
          submit = submitForm
        }}
        onSubmit={values => {
          onSubmit(values)
          next()
        }}
        onChange={onChange}
        defaultValue={defaultValue}
        defaultCountry={defaultCountry}
        searchOnClick={searchOnClick}
        searchValues={teamsByCodeInEvent}
        teamCodes={teamCodes}
        teamsByCode={teamsByCode}
        teamsInEvent={teamsInEvent}
        disableQuestions={disableQuestions}
      />
      <NavigationButtons
        buttonColour={buttonColour}
        buttonTextColour={buttonTextColour}
        preventDefaultOnBack={preventDefaultOnBack}
        hideBackButton
        isContinueDisabled={isNextDisabled}
        onSubmit={() => submit()}
      />
    </div>
  )
}

export default TeamsComponent
